<template>
    <div class="sphere-loader-block">
        <div class="sphere-loader" :class="loaderClass">
            <div class="inner one"></div>
            <div class="inner two"></div>
            <div class="inner three"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loaderClass: {
            type: String,
            default: ''
        }
    }
}
</script>

<style>
    @import "@/styles/css/loaders.css";
</style>